export const GET_API_DATA_LIST = "GET_API_DATA_LIST@HOME"
export const SET_FORM_VALUE = "SET_FORM_VALUE@HOME"
export const SET_FORM_VALUEOBJ = "SET_FORM_VALUEOBJ@HOME"
export const SET_ERROR_MESSAGE = "SET_ERROR_MESSAGE@HOME"
export const CLEAR_ALL_ERROR_MESSAGE = "CLEAR_ALL_ERROR_MESSAGE@HOME"
export const CLEAR_ERROR_MESSAGE = "CLEAR_ERROR_MESSAGE@HOME"
export const RESET_NEWASSETS_FORM = "RESET_NEWASSETS_FORM@HOME"
export const LOAD_API_DATA = "LOAD_API_DATA@HOME"
export const RESET_API_DATA = "RESET_API_DATA@HOME"
export const SET_API_DATA = "SET_API_DATA@HOME"
export const SET_FORM_OPTION = "SET_FORM_OPTION@HOME"